import { P2GAdaptiveOverlay, P2GBox } from '@parcel2go/core-ui';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const CmsContent = lazy(() => import('~/components/core/content/cms-content'));

type DropOffMoreInfoProps = { open: boolean; onClose: () => void };

export const DropOffMoreInfo = ({ open, onClose }: DropOffMoreInfoProps) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  return (
    <P2GAdaptiveOverlay
      isOpen={open}
      onClose={onClose}
      modalTitle={''}
      closeButtonText={t('CLOSE_DRAWER', { defaultValue: 'Close' })}
    >
      <P2GBox p={2}>
        <Suspense>
          <CmsContent contentKey="sidepanel-drop-shop-message" />
        </Suspense>
      </P2GBox>
    </P2GAdaptiveOverlay>
  );
};
